import FormSelectSearchable from './FormSelectSearchable';

export default FormSelectSearchable;
